var _excluded = ["children", "activeStep"];

var _templateObject, _templateObject2, _templateObject3;

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled, { css } from 'styled-components';
import { limitChildren, typeOf } from '../../shared';
import Dots from './Dots';
import Line from './Line';
import Step from './Step';
var Root = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 100%;\n\n  * {\n    box-sizing: border-box;\n  }\n"])));
var LineWrapper = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var stepper = _ref.theme.yoga.components.stepper;
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 46px;\n\n    padding: 0 ", "px 0 ", "px;\n  "])), stepper.padding.right, stepper.padding.left);
});
/** Stepper is responsible for the logic that drives a stepped workflow, it
provides a wizard-like workflow by dividing content into logical steps. */

var Stepper = function Stepper(_ref2) {
  var children = _ref2.children,
      activeStep = _ref2.activeStep,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Root, rest, /*#__PURE__*/React.createElement(LineWrapper, null, /*#__PURE__*/React.createElement(Line, {
    width: activeStep <= 0 ? 0 : activeStep / (React.Children.count(children) - 1) * 100
  }), /*#__PURE__*/React.createElement(Dots, {
    activeStep: activeStep,
    labels: React.Children.map(children, function (child) {
      return child.props.label;
    })
  })), React.Children.toArray(children)[activeStep]);
};

Stepper.displayName = 'Stepper';
Stepper.propTypes = {
  /** Must be a Stepper.Step component. */
  children: typeOf(Step),

  /** Controls the active step, it receive the index value for showing some
   * step. Starting from 0. */
  activeStep: limitChildren
};
Stepper.defaultProps = {
  children: undefined,
  activeStep: 0
};
export default Stepper;